import { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { playBoosterWindowOpen } from '@wg/web2clientapi/sound';

import type { Action } from 'redux';
import type { ThunkDispatch } from 'redux-thunk';
import type { RootState } from '~/store';
import type { i18n_Props } from '~/i18n';
import type { IBooster } from '~/types';

import ViewDialogs from '~/Components/ViewDialogs/ViewDialogs';
import {
    closeBoosterDialog,
    closeBuyoutDialog,
    closeErrorDialog,
    closeFinalDialog,
    closeMultipleBuyDialog,
    closeRulesDialog,
    closeShipFeaturesDialog,
    closeStartBuyDialog,
    closeWelcomeDialog,
    hideOverlay,
    openBoosterDialog,
    openBuyoutDialog,
    openErrorDialog,
    openFinalDialog,
    openMultipleBuyDialog,
    openRulesDialog,
    openShipFeaturesDialog,
    openStartBuyDialog,
    openWelcomeDialog,
} from '~/store/dialogs';

type OwnProps = i18n_Props;

interface DispatchProps {
    openWelcomeDialog: () => void,
    closeWelcomeDialog: () => void,
    openRulesDialog: () => void,
    closeRulesDialog: () => void,
    openBoosterDialog: (booster: IBooster) => void,
    closeBoosterDialog: () => void,
    openErrorDialog: (error: Error) => void,
    closeErrorDialog: () => void,
    openBuyoutDialog: () => void,
    closeBuyoutDialog: () => void,
    openFinalDialog: (shipName: string) => void,
    closeFinalDialog: () => void,
    hideOverlay: () => void,
    openMultipleBuyDialog: () => void,
    closeMultipleBuyDialog: () => void,
    openStartBuyDialog: () => void,
    closeStartBuyDialog: () => void,
    openShipFeaturesDialog: (shipId: string | number) => void,
    closeShipFeaturesDialog: () => void,
}

interface StateProps {
    isRulesDialogOpen: boolean,
    isBoosterDialogOpen: boolean,
    isWelcomeDialogOpen: boolean,
    isErrorDialogOpen: boolean,
    isBuyoutDialogOpen: boolean,
    isFinalDialogOpen: boolean,
    noAnimation: boolean,
    isOverlayVisible: boolean,
    isMultipleBuyDialogVisible: boolean,
    isStartBuyDialogVisible: boolean,
    isBundleBuyDialogVisible: boolean,
    isShipFeaturesDialogVisible: boolean,
    shipFeaturesDialogShipId: number | null,
    mainRewardShipId: string,
}

export type Props = StateProps & OwnProps & DispatchProps;

class ContainerDialogs extends PureComponent<Props> {
    render() {
        return <ViewDialogs {...this.props} />;
    }
}

const mapStateToProps = (state: RootState): StateProps => ({
    isRulesDialogOpen: state.dialogs.isRulesDialogOpen,
    isBoosterDialogOpen: state.dialogs.isBoosterDialogOpen,
    isWelcomeDialogOpen: state.dialogs.isWelcomeDialogOpen,
    isErrorDialogOpen: state.dialogs.isErrorDialogOpen,
    isBuyoutDialogOpen: state.dialogs.isBuyoutDialogOpen,
    isFinalDialogOpen: state.dialogs.isFinalDialogOpen,
    noAnimation: state.app.noAnimation,
    isOverlayVisible: state.dialogs.isOverlayVisible,
    isMultipleBuyDialogVisible: state.dialogs.isMultipleBuyDialogVisible,
    isStartBuyDialogVisible: state.dialogs.isStartBuyDialogVisible,
    isBundleBuyDialogVisible: state.dialogs.isBundleBuyDialogVisible,
    isShipFeaturesDialogVisible: state.dialogs.isShipFeaturesDialogVisible,
    shipFeaturesDialogShipId: state.dialogs.shipFeaturesDialogShipId,
    mainRewardShipId: state.app.mainRewardShipId,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, unknown, Action>): DispatchProps => {
    return {
        openWelcomeDialog: () => {
            dispatch(openWelcomeDialog(false));
        },
        closeWelcomeDialog: () => {
            dispatch(closeWelcomeDialog());
        },
        openBoosterDialog: (booster: IBooster) => {
            playBoosterWindowOpen();
            dispatch(openBoosterDialog(booster));
        },
        closeBoosterDialog: () => {
            dispatch(closeBoosterDialog());
        },
        openRulesDialog: () => {
            dispatch(openRulesDialog());
        },
        closeRulesDialog: () => {
            dispatch(closeRulesDialog());
        },
        openErrorDialog: (error: Error) => {
            dispatch(openErrorDialog(error));
        },
        closeErrorDialog: () => {
            dispatch(closeErrorDialog());
        },
        openBuyoutDialog: () => {
            dispatch(openBuyoutDialog());
        },
        closeBuyoutDialog: () => {
            dispatch(closeBuyoutDialog());
        },
        openFinalDialog: (shipName: string) => {
            dispatch(openFinalDialog(shipName));
        },
        closeFinalDialog: () => {
            dispatch(closeFinalDialog());
        },
        openMultipleBuyDialog: () => {
            dispatch(openMultipleBuyDialog());
        },
        closeMultipleBuyDialog: () => {
            dispatch(closeMultipleBuyDialog());
        },
        hideOverlay: () => {
            dispatch(hideOverlay());
        },
        openStartBuyDialog: () => {
            dispatch(openStartBuyDialog());
        },
        closeStartBuyDialog: () => {
            dispatch(closeStartBuyDialog());
        },
        openShipFeaturesDialog: (shipId: string | number) => {
            dispatch(openShipFeaturesDialog(shipId));
        },
        closeShipFeaturesDialog: () => {
            dispatch(closeShipFeaturesDialog());
        },
    };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ContainerDialogs));
